import Counter from "../../features/counter/Counter";

export const EnhancedCounter = ({
  setReferencePopup,
  pathname,
  search,
  forwardRef,
  setIsCalculator,
  setCalculatorType,
}) => {
  return (
    <div>
      <h2>Enhanced Counter</h2>
      <Counter
        pathname={pathname}
        search={search}
        setReferencePopup={setReferencePopup}
        ref={forwardRef}
        setIsCalculator={setIsCalculator}
        setCalculatorType={setCalculatorType}
      />
    </div>
  );
};
